<script setup lang="ts">
import type { AlertDialogCancelProps } from "reka-ui"
import type { HTMLAttributes } from "vue"
import { AlertDialogCancel, useForwardProps } from "reka-ui"
import { computed } from "vue"
import { cn } from "@/shared/lib/utils"
import { buttonVariants } from "@/shared/ui/button"

// Кнопка скасування (закриває діалог без дії). Reka автофокусить її при відкритті.
const props = defineProps<
  AlertDialogCancelProps & { class?: HTMLAttributes["class"] }
>()

const delegatedProps = computed(() => {
  const { class: _class, ...rest } = props
  return rest
})
const forwarded = useForwardProps(delegatedProps)
</script>

<template>
  <AlertDialogCancel
    data-slot="alert-dialog-cancel"
    v-bind="forwarded"
    :class="cn(buttonVariants({ variant: 'outline' }), props.class)"
  >
    <slot />
  </AlertDialogCancel>
</template>
